/**
* Hero Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import ScrollMagic from 'ScrollMagic';
// import animationGSAP from 'animation.gsap';
// import addIndicators from 'debug.addIndicators';
// import TweenMax from 'TweenMax';
// import TimelineMax from 'TimelineMax';
( function( app ) {
  const COMPONENT = {

    className: 'hero-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.hero-banner__image' ).length > 1 ) {
        $( '.hero-banner__images' ).slick( {
          dots: false,
          arrows: false,
          autoplay: true,
          speed: 1000,
          autoplaySpeed: 5000,
          fade: true,
          cssEase: 'linear',
          infinite: true,
        } );
      }

      $( '.hero-banner__images' ).on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
        const perc = ( nextSlide / ( $( '.hero-banner__image' ).length - 1 ) ) * 100;
        $( '.hero-banner .custom-dots .tracker' ).css( 'transform-origin', perc + '% center' );
      } );

      $( '.hero-banner .custom-dots button' ).click( function() {
        $( '.hero-banner__images' ).slick( 'slickGoTo', $( this ).attr( 'data-slide' ) );
      } );

      $( '.hero-banner .slider-prev' ).click( function() {
        $( '.hero-banner__images' ).slick( 'slickPrev' );
      } );

      $( '.hero-banner .slider-next' ).click( function() {
        $( '.hero-banner__images' ).slick( 'slickNext' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-banner', COMPONENT );
} )( app );
